<template>
	<div
		class="sk-input-wrapper"
		:class="{
			focused: focused || content.length > 0,
			'is-editing': focused,
			'has-error': errorMsg
		}"
	>
		<input
			class="sk-input"
			v-model="content"
			:type="type"
			:ref="'skInput'"
			:name="name"
			:placeholder="placeholder"
			@input="handleInput"
			@focus="setFocused()"
			@blur="setBlurred()"
		/>
		<label class="sk-placeholder" @click="focusInput">{{ label }}</label>
	</div>
</template>

<style lang="scss" scoped>
.sk-input {
	border: 1px solid var(--gR-white2);
}
.sk-input {
	&:-webkit-autofill,
	&:-webkit-autofill:hover,
	&:-webkit-autofill:focus,
	&:-webkit-autofill:active {
		-webkit-box-shadow: 0 0 0 60px var(--gR-white) inset !important;
		background-color: var(--gR-white) !important;
		background-clip: content-box !important;
	}
}

.sk-input-wrapper {
	position: relative;
	border: 1px solid var(--gR-white2);
	background: var(--gR-white);
	border-radius: 5px;
	width: 100%;
	height: 50px;
	overflow: hidden;

	&.has-error {
		border: 1px solid var(--sk-red);

		.sk-placeholder {
			color: var(--sk-red);
		}
	}

	&.is-editing {
		border: 1px solid var(--gR-base-90);
	}

	&.focused {
		.sk-placeholder {
			top: 7px;
			font-size: 10px;
		}

		.sk-input {
			opacity: 1;
			bottom: 7px;
		}
	}
}

.sk-input,
.sk-placeholder {
	width: 100%;
	position: absolute;
	left: 0;
	padding-left: 15px;
	transition: all 0.25s ease-in;
	font-size: 14px;
}

.sk-input {
	color: var(--sk-grey);
	opacity: 0;
	border: 0;
	padding-bottom: 0;
	font-size: 14px;
	bottom: 0;
	outline: 0;
	background: none;
}

.sk-placeholder {
	margin-bottom: 0;
	color: var(--sk-grey2);
	top: calc((100% - 21px) / 2);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>

<script>
import phoneFilterMixin from "@/mixins/phone-filter-mixin"

export default {
	name: "SkInput",
	mixins: [phoneFilterMixin],
	props: {
		name: String,
		type: {
			type: String,
			default: "text"
		},
		required: {
			type: Boolean,
			default: false
		},
		validation: RegExp,
		placeholder: String,
		value: String,
		autoFocus: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			focused: false,
			content: this.maskInput(this.value),
			rawValue: this.value,
			errorMsg: null,
			validationEnabled: false
		}
	},
	computed: {
		label: function () {
			return this.errorMsg ? this.errorMsg : this.name
		}
	},
	methods: {
		scrollIntoView(element, behavior) {
			let scrollTop = window.pageYOffset || element.scrollTop
			let rect = element.getBoundingClientRect()
			const finalOffset = rect.top + scrollTop - rect.height - 10

			window.scrollTo({
				top: finalOffset,
				behavior: behavior || "auto"
			})
		},
		maskInput(value) {
			if (this.type === "tel") {
				this.rawValue = value.replace(/[\s)(-]/g, "")
				this.content = this.$options.filters.maskPhoneInput(
					this.rawValue
				)
			} else {
				this.rawValue = value
				this.content = this.rawValue
			}
			return this.content
		},
		handleInput(e) {
			if (!e.isTrusted) {
				return
			}
			this.maskInput(e.target.value)
			this.$emit("input", this.rawValue)
		},
		setFocused() {
			this.$emit("focus")
			this.focused = true
			if (this.autoFocus) {
				this.scrollIntoView(this.$refs.skInput, "smooth")
			}
		},
		setBlurred() {
			this.$emit("blur")
			this.focused = false
			if (this.rawValue != this.$refs.skInput.value) {
				this.maskInput(this.$refs.skInput.value)
				this.$emit("input", this.rawValue)
			}
			if (this.validationEnabled) {
				this.validate()
			}
		},
		validate() {
			this.validationEnabled = true
			let msg = null
			if (
				this.required &&
				(!this.content ||
					this.content.length <= 0 ||
					this.content.replace(/\s/g, "").length == 0)
			) {
				msg = this.name + " Required"
			}
			if (this.validation && !this.validation.test(this.rawValue)) {
				msg = this.name + " Invalid"
			}
			this.errorMsg = msg
			if (msg) {
				return false
			}
			return true
		},
		resetValidation() {
			this.validationEnabled = false
			this.errorMsg = null
		},
		focusInput() {
			this.$refs.skInput.focus()
		}
	},
	watch: {
		value(value) {
			if (value != this.rawValue) {
				this.maskInput(value)
			}
		}
	}
}
</script>